// extracted by mini-css-extract-plugin
export var details = "icon-module--details--90522";
export var icon = "icon-module--icon--1a7c5";